import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from './LegalLayout';
import { legalNotice } from './legalContent';
import Seo from '../../components/Seo';

const LegalNotice = () => {
  const { t, i18n } = useTranslation();
  const lang = ['fr', 'en', 'nl'].includes(i18n.language) ? i18n.language : 'fr';
  const content = legalNotice[lang];

  const breadcrumbLabel = { fr: 'Accueil', en: 'Home', nl: 'Home' }[lang];
  const otherLabel = {
    fr: 'Politique de confidentialité',
    en: 'Privacy Policy',
    nl: 'Privacybeleid',
  }[lang];

  return (
    <>
      <Seo title={t('seo.legal.title')} description={t('seo.legal.desc')} noIndex />
      <LegalLayout
        content={content}
        breadcrumbLabel={breadcrumbLabel}
        otherLinkTo="/politique-confidentialite"
        otherLinkLabel={otherLabel}
        testIdPrefix="legal-notice"
      />
    </>
  );
};

export default LegalNotice;
